type LogoProps = {
  size?: number;
  className?: string;
};

/**
 * Wordmark for the admin app. Renders the same "S" mark used in the
 * favicon, followed optionally by text. Kept tiny and dependency-free
 * so it can be reused in the sidebar, login page, and emails.
 */
export const Logo = ({ size = 28, className }: LogoProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-hidden="true"
  >
    <rect width="32" height="32" rx="6" fill="#5C1F22" />
    <path
      d="M9 22V10h6.2c2.4 0 4 1.4 4 3.5 0 1.4-.8 2.4-2 2.9 1.6.4 2.6 1.6 2.6 3.2 0 2.1-1.7 3.4-4.3 3.4H9zm2.4-7.2h3.4c1.1 0 1.8-.6 1.8-1.5s-.7-1.5-1.8-1.5h-3.4v3zm0 5.2h3.7c1.2 0 2-.6 2-1.6s-.8-1.6-2-1.6h-3.7v3.2z"
      fill="#FEFCF7"
    />
  </svg>
);

export const BrandWordmark = ({ className }: { className?: string }) => (
  <div className={`flex items-center gap-2 ${className ?? ''}`}>
    <Logo size={28} />
    <div className="flex flex-col leading-tight">
      <span className="font-serif text-base font-semibold text-fg-base">Sweet Home</span>
      <span className="text-2xs uppercase tracking-wider text-fg-muted">Admin</span>
    </div>
  </div>
);
